import { Loader2 } from "lucide-react";

const sizeMap = {
	sm: 16,
	md: 24,
	lg: 40,
} as const;

interface SpinnerProps {
	size?: keyof typeof sizeMap;
	label?: string;
	className?: string;
}

export function Spinner({ size = "md", label = "Laden...", className = "" }: SpinnerProps) {
	return (
		<output aria-label={label} className={`inline-flex items-center ${className}`}>
			<Loader2 size={sizeMap[size]} className="animate-spin text-primary" />
			<span className="sr-only">{label}</span>
		</output>
	);
}
